export default "__VITE_PUBLIC_ASSET__0f063779__"